import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, FileText, Scale, Gift, Heart, Shield } from 'lucide-react';
import FeedbackButton from '@/components/FeedbackButton';

const LOGO_URL = "https://customer-assets-rejwkqb3.emergentagent.net/job_5700d295-d3ed-4629-8765-e98307778f89/artifacts/bbyq8lme_icone_verre_vert_512.png";

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-slate-300 py-8 mt-auto">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Logo et description */}
          <div>
            <div className="flex items-center gap-2 mb-3">
              <img 
                src={LOGO_URL} 
                alt="copropriete.app" 
                className="h-10 w-auto rounded-lg"
              />
              <span className="font-bold text-white">copropriete.app</span>
            </div>
            <p className="text-sm text-slate-400">
              L'application gratuite qui redonne le pouvoir aux copropriétaires.
            </p>
          </div>

          {/* 100% Gratuit */}
          <div>
            <h4 className="font-semibold text-white mb-3 flex items-center gap-2">
              <Gift className="w-4 h-4 text-emerald-400" />
              100% Gratuit
            </h4>
            <ul className="space-y-1 text-sm">
              <li className="text-emerald-400 font-medium flex items-center gap-1">
                <Heart className="w-3 h-3" />
                Sans abonnement
              </li>
              <li className="text-slate-400 text-xs">Aucune carte bancaire requise</li>
              <li className="text-slate-400 text-xs mt-2">Toutes les fonctionnalités incluses</li>
              <li className="text-slate-500 text-xs mt-2 flex items-center gap-1">
                <Shield className="w-3 h-3" />
                Services postaux AR à l'acte
              </li>
            </ul>
          </div>

          {/* Liens légaux */}
          <div>
            <h4 className="font-semibold text-white mb-3">Informations légales</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <Link 
                  to="/mentions-legales"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-legal-notice"
                >
                  <Scale className="w-4 h-4" />
                  Mentions légales
                </Link>
              </li>
              <li>
                <Link 
                  to="/cgu"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-cgu"
                >
                  <FileText className="w-4 h-4" />
                  CGU
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-semibold text-white mb-3">Contact</h4>
            <ul className="space-y-2 text-sm">
              <li>
                <a 
                  href="mailto:gmpdeveloppement@gmail.com"
                  className="flex items-center gap-2 hover:text-white transition-colors"
                  data-testid="footer-contact"
                >
                  <Mail className="w-4 h-4" />
                  gmpdeveloppement@gmail.com
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Feedback button centré */}
        <div className="mt-8 text-center border-t border-slate-800 pt-6">
          <FeedbackButton />
        </div>

        {/* Disclaimer */}
        <div className="mt-6 text-center text-xs text-slate-500">
          <p>copropriete.app est un outil d'assistance au syndic bénévole. Les décisions et responsabilités relèvent exclusivement du syndic désigné.</p>
        </div>

        {/* Copyright */}
        <div className="mt-4 text-center text-sm text-slate-500 border-t border-slate-800 pt-4">
          © 2026 GMP Développement. Tous droits réservés.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
